import api from "./resetPasswordApi";
import {
  resetPasswordError,
  resetPasswordInit,
  resetPasswordPending,
  resetPasswordSuccess,
} from "./resetPasswordStateActions";
import { parseApiError } from "../../../utils/apiError";
import { PasswordChangeHttpRequest } from "../../parentApi";
export function ResetPassword(
  dispatch: any,
  customerAccountId: number,
  customerContactId: number,
  currentPassword: string,
  newPassword: string
) {
  dispatch(resetPasswordPending());
  api
    .passwordChange(
      customerAccountId,
      customerContactId,
      new PasswordChangeHttpRequest({
        currentPassword: currentPassword,
        newPassword: newPassword,
      })
    )
    .then(
      function () {
        dispatch(resetPasswordSuccess());
      },
      function (error: unknown) {
        const parsed = parseApiError(
          error,
          "An error ocurred while trying to change your password. Please try again later"
        );
        dispatch(resetPasswordError(parsed.message, parsed.correlationId));
      }
    )
    .finally(function () {
      setTimeout(() => {
        dispatch(resetPasswordInit());
      }, 500);
    });
}

export function initRsetPassword() {
  return function (dispatch: any) {
    dispatch(resetPasswordInit());
  };
}
